
export const shouldShowJiraWidget = (opts: { isBrandingEnabled: boolean, isExternalUser: boolean; }) => {
  return !opts.isExternalUser;
};